import type { FormInstance } from 'antd';
import type { RuleObject } from 'antd/es/form';
import type { TFunction } from 'i18next';

type ExtendedRuleObject = RuleObject & {
  field?: string;
};

export interface Stop {
  sequence: number;
  stopType?: string;
  countryCode?: string;
  companyName?: string | null;
  city?: string | null;
  name?: string | null;
  addr1?: string | null;
  addr2?: string | null;
  portType?: string | null;
  portRecKey?: string | null;
  portCode?: string | null;
  portState?: string | null;
  portZip?: string | null;
  isValidLocation?: boolean;
  editMode?: boolean;
  gridOperation?: number;
  isNew?: boolean;
}

export const initialValues = {
  consigneeAdditionalInformations: [{ distance: null }],
  ports: [
    {
      addr1: null,
      addr2: null,
      city: null,
      companyName: null,
      countryCode: 'US',
      editMode: true,
      gridOperation: 1,
      isNew: true,
      isValidLocation: false,
      name: null,
      portCode: null,
      portRecKey: null,
      portState: null,
      portType: null,
      portZip: null,
      sequence: 1,
      stopType: '1', // pickup
    },
    {
      addr1: null,
      addr2: null,
      city: null,
      companyName: null,
      countryCode: 'US',
      editMode: true,
      gridOperation: 1,
      isNew: true,
      isValidLocation: false,
      name: null,
      portCode: null,
      portRecKey: null,
      portState: null,
      portType: null,
      portZip: null,
      sequence: 2,
      stopType: '2', // delivery
    },
  ],
  transportationMode: null,
};

export const sequenceStopSorting = (a: Stop, b: Stop) => {
  if (a.sequence > b.sequence) {
    return 1;
  }
  if (a.sequence < b.sequence) {
    return -1;
  }
  return 0;
};

export const stopTypeRules = (t: TFunction, form: FormInstance) => [
  {
    validator: async (rule: ExtendedRuleObject, value: unknown) => {
      const fieldIndex = rule.field?.split('.')[1];
      const numberOfStops = form.getFieldsValue(true).ports.length;
      if (!value) {
        return Promise.reject(t('translation:getQuote.transportationDetails.stopType.message'));
      }
      if (Number(fieldIndex) === 0 && value !== '1' && numberOfStops > 1) {
        return Promise.reject('Stop Type for the first stop should be Pick Up');
      }
      if (Number(fieldIndex) === numberOfStops - 1 && value !== '2' && numberOfStops > 1) {
        return Promise.reject('Stop Type for the last stop should be Delivery');
      }
      return Promise.resolve();
    },
  },
];

export const additionalStopsValidation = (form: FormInstance) => [
  {
    validator: () => {
      const stops: Stop[] = form.getFieldValue('ports');
      const isHavePickup = stops.some((item) => item.stopType === '1');
      const isHaveDelivery = stops.some((item) => item.stopType === '2');

      if (!isHavePickup || !isHaveDelivery) {
        return Promise.reject(
          'At least One pickup and Delivery Stop must be provided (Country and City) in order to save the quote.',
        );
      }

      return Promise.resolve();
    },
  },
];
